module.exports = fox => {
	require('./stylus/_guest-purchase-popup.styl');
	require('./stylus/_discount-sicker.styl');
	require('fox-dynamic-injection!fox-template-loader!./templates/guestPurchasePopup.tpl')(fox);
	require('./widget/GuestPurchasePopup')(fox);

	require('./widget/LoginForm')(fox);
	require('fox-dynamic-injection!fox-template-loader!./templates/autoLoginPopup.tpl')(fox);
	require('./widget/AutoLoginPopup')(fox);

	require('./images/discount-sticker.png');
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/common/index.es.js